// SkyBattleSea — native (Capacitor) adaptation. No-ops entirely on the web build.
//
// Fullscreen status bar and the Android back button: Back closes an open <dialog> (decision or
// confirm), otherwise backgrounds the app. The `native-app` class and the `.overlay` check are
// kept for CSS hooks; the engine-range shell has no sign-in UI.
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar } from '@capacitor/status-bar';

export function initNative(): void {
  if (!Capacitor.isNativePlatform()) return;
  document.documentElement.classList.add('native-app');

  // Fullscreen: draw under the (hidden) status bar; safe-area CSS already handles the notch.
  StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
  StatusBar.hide().catch(() => {});

  // Android back button: close the topmost open overlay, else background the app
  // (never exit-kill — matches player expectations for games).
  App.addListener('backButton', () => {
    const dialog = document.querySelector<HTMLDialogElement>('dialog[open]');
    if (dialog) { dialog.close(); return; }
    const open = document.querySelector<HTMLElement>('.overlay:not(.hidden)');
    if (open) open.classList.add('hidden');
    else App.minimizeApp();
  });
}
